import styled from "styled-components";

export const ErrorLabel = styled.div`
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;

  color: ${p => p.warning ? '#E6B300' : '#FD2020'};
`;